export default __webpack_public_path__ + "static/market-index-treemap-7ac35e30b1c18fbe5ab07b7c0e44714e.png";